<template>
  <nx-year-picker
    v-validate="validation"
    :data-vv-name="name"
    :data-vv-scope="scope"
    :data-vv-as="label"
    data-vv-value-path="value"
    :value="value"
    :name="name"
    :label="label"
    :required="required"
    :disabled="disabled"
    :error-messages="errorMessages"
    @input="onInput"
    @focus="onFocus"
    v-bind="$attrs"
  />
</template>

<script>
import FormElement from '@/modules/form/mixins/form-element';
import NxYearPicker from '@/components/date/YearPicker';

export default {
  components: {
    NxYearPicker,
  },
  name: 'nx-form-year-picker',
  mixins: [FormElement],
  props: {
    // Field name
    name: {
      type: String,
      required: true,
    },
    // Component label.
    label: {
      type: String,
    },
    value: {
      type: [String, Number],
    },
  },
  methods: {
    onInput(newValue) {
      this.$emit('input', newValue);
      this.$parentForm.updateField(this.name, newValue);
    },
    onBlur() {
      this.$emit('blur', true);
      this.flags.focused = false;
    },
    onFocus() {
      this.$emit('focus', true);
      this.flags.focused = true;
    },
  },
};
</script>
